<template>
    <div class="image-text-section">
        <div>
            <h2>{{ headline }}</h2>
            <RichText :text="text" />
        </div>
        <div class="laptop:w-1/2 laptop:shrink-0 tv:w-7/12">
            <img :src="image.filename" />
        </div>
    </div>
</template>
<script lang="ts" setup>
import RichText from '@/components/RichText.vue';
import type { SbImage } from '@/components/StoryblokComponent.vue';
import type { ISbRichtext } from 'storyblok-js-client';

defineProps<{ headline: string; text: ISbRichtext; image: SbImage }>();
</script>

<style lang="scss" scoped>
.image-text-section {
    @apply flex
        flex-col
        items-center
        gap-12;

    @screen laptop {
        @apply flex-row
            gap-21;
    }

    p {
        @apply mb-4;

        @screen laptop {
            @apply mb-6;
        }

        &:last-child {
            @apply mb-0;
        }

        b {
            @apply font-normal
                text-primary;
        }
    }

    img {
        @apply w-full;
    }
}
</style>
